import * as uuid from 'uuid';

import * as api from '../../api';
import * as store from '../../reducers/store';

import { StaticStatus } from '../../components/Question';
import * as FormUtils from './index';

const { Primitive } = api.PrevisitFormTemplateFieldConfig;

export function makeFormField(
  args: Partial<api.PrevisitFormField.PrevisitFormFieldWithConfig> = {},
): api.PrevisitFormField.PrevisitFormFieldWithConfig {
  return {
    id: uuid.v4(),
    created: new Date().toISOString(),
    updated: new Date().toISOString(),
    rank: 1,
    required: true,
    defaultValue: '',
    source: null,
    sublabel: null,
    placeholder: null,
    min: null,
    max: null,
    interval: null,
    prefix: null,
    suffix: null,
    dataBinding: null,
    previsitFormId: 'this-is-a-form-id',
    previsitFormSetId: 'this-is-a-form-set-id',
    previsitFormTemplateFieldConfigId: '',
    value: '',
    deleted: false,
    deletedTimestamp: null,
    name: '',
    page: 1,
    label: 'This is a question',
    options: null,
    primitive: Primitive.Enum,
    previsitFormTemplateId: '',
    conditions: [],
    helpDialog: null,
    helpDialogLabel: null,
    fhirAppointmentKinds: null,
    fhirTotalResult: null,
    fhirDynamicProviders: null,
    scheduleAppointmentDisplayBy: null,
    scheduleAppointmentSortBy: null,
    scheduleAppointmentStartTime: null,
    scheduleAppointmentEndTime: null,
    scheduleAppointmentCallSectionEnabled: false,
    scheduleAppointmentCommentEnabled: false,
    hidePatientCareProvidersIfPopulated: false,
    lastPage: null,
    registrationEnableContactVerification: null,
    registrationAdditionalLoginInputs: null,
    registrationFhirEhrReconciliation: null,
    registrationEhrProviderInformationId: null,
    optionsMetadata: null,
    scheduleAppointmentDefaultReasonForVisit: null,
    hideContinueButton: false,
    formQuestionEhrId: null,
    characterLimit: null,
    customConfigs: {},
    ...args,
  };
}

export async function validateFields({
  formSetId,
  fields,
  formFields,
  practicePreference,
  patient,
  save,
}: {
  formSetId: string;
  fields: store.FormFieldWithConfig[];
  formFields: store.FormFieldWithConfig[];
  practicePreference: api.Previsit.PracticePreference;
  patient: api.Patient.Patient | null;
  save?: boolean;
}): Promise<void> {
  await FormUtils.validatePageValues(
    fields,
    formFields,
    patient,
    practicePreference,
  );
  if (!save) return;
  const updated = markStaticAsSubmitted(fields);
  return api.client.Previsit.updateFormFields(formSetId, updated);
}

function markStaticAsSubmitted(
  toUpdate: store.FormFieldWithConfig[],
): store.FormFieldWithConfig[] {
  return toUpdate.map((formField) => {
    if (
      formField.value === StaticStatus.Viewed &&
      formField.primitive === Primitive.Static
    ) {
      return { ...formField, value: StaticStatus.Submitted };
    }
    return formField;
  });
}
